import withTooltipOnInputLabel from './withTooltipOnInputLabel';

export default withTooltipOnInputLabel;
